import { render } from "./IconDrug.vue?vue&type=template&id=2f42514f&scoped=true"
const script = {}

import "./IconDrug.vue?vue&type=style&index=0&id=2f42514f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f42514f"],['__file',"src/components/icon/IconDrug.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f42514f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f42514f', __exports__)) {
    api.reload('2f42514f', __exports__)
  }
  
  module.hot.accept("./IconDrug.vue?vue&type=template&id=2f42514f&scoped=true", () => {
    api.rerender('2f42514f', render)
  })

}


export default __exports__